/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid,no-undef */
import React, { useState } from "react";

import { Form } from "react-bootstrap";
import { useFormik } from "formik";
import { CancelSubscriptionSchema } from "../order-form/validationSchema";
import SnackBarTool from "../../../../_metronic/_partials/widgets/snack-bar/SnackBar";
import {
  cancelSubscription,
  cancellationPrice,
} from "../_redux/order/orderCrud";
import { useIntl } from "react-intl";
import { canvaCancel } from "../../../utils/canvaCloseFunction";
import {
  fetchBillingCardDetail,
  fetchMyOrderDetailCard,
  fetchMyOrderTimeline,
  fetchPaymentInvoice,
} from "../_redux/order/orderAction";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { MenuItem, FormControl, Select } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { convertGBPtoPoundSymbol, isDateToday, isDateWithinNext3Days, isOneWeekdayGap, getApiErrorMessage } from "../../../utils/commonFunction";
import { useEffect } from "react";
export function CancelSubscription({ orderDetail, billingCard, eightCharge }) {
  const dispatch = useDispatch();
  const intl = useIntl();

  const [snack, setSnack] = useState({ call: false, type: "", message: "" });
  const [loading, setLoading] = useState(false);
  const [price, setPrice] = useState(null);
  const [remain, setRemain] = useState(0);

  const initialValues = {
    order_id: orderDetail?.id || "",
    franchise_id: orderDetail?.franchise_id || "",
    subscription_id: orderDetail?.subscription_id || "",
    credit_option: "none",
    cancel_category: "",
    cancel_reason: "",
    refundable_credits_handling: "no_action",
    is_cancel_charge: "0",
  };

  const getReasonsByCategory = (category) => {
  const reasons = {
    "Pricing & Value": [
      "Found cheaper alternative",
    ],
    "Access & Logistics": [
      "Access hours unsuitable",
      "Collection/delivery dates unavailable",
      "Requires ground floor access",
      "Unit size unsuitable",
    ],
    "Customer Situation": [
      "Property move delayed",
      "House move cancelled",
      "Moved outside service area",
      "Using friend/family storage space",
      "Chose to sell/dispose of items",
      "Transferred to another franchise/site",
      "Switched to different easyStorage service",
    ],
    "Customer Experience": [
      "Misunderstood service offering",
      "Poor post-booking call experience",
      "Concern about online reviews/reputation",
      "Security concerns",
    ],
    "Administrative & Other": [
      "Did not attend on scheduled day",
      "Duplicate booking",
      "Test/enquiry-only booking",
      "No reason provided",
    ],
  };
  return reasons[category] || [];
};


  const { orderDropDown } = useSelector(
    (state) => ({
      orderDropDown: state.order.orderDropDown,
    }),
    shallowEqual
  );

  console.log("orderDropDown", orderDropDown);

  const handleSubmit = (values, actions) => {
    setSnack({
      call: false,
      type: "",
      message: "",
    });
    setLoading(true);
    if (orderDetail.is_container == 1) {
      values.is_container = 1;
      if (remain) {
        values.eighty_percent_amount = remain;
      }
    }
    if (values?.credit_option === "fullRefund") {
      values.credit_option = "fullRefund";
      values.is_cancel_charge = 1;
    }
    // delete values.credit_option;
    cancelSubscription(values)
      .then((res) => {
        setSnack({ call: true, type: "success", message: res.data.message });
        actions.resetForm({ values: "" });
        canvaCancel("kt_CancelSubscription_panel_close");
        setLoading(false);
        dispatch(fetchMyOrderDetailCard(orderDetail?.id));
        dispatch(fetchMyOrderTimeline(orderDetail?.id));
        dispatch(
          fetchPaymentInvoice(
            orderDetail?.id,
            orderDetail?.franchise_id,
            orderDetail?.subscription_id
          )
        );
        dispatch(
          fetchBillingCardDetail(
            orderDetail?.franchise_id,
            orderDetail?.subscription_data?.id
          )
        );
      })
      .catch((error) => {
        setSnack({
          call: true,
          type: "error",
          message: getApiErrorMessage(error),
        });
        setLoading(false);
      });
  };

  const handleReset = () => {};

  const getInputClasses = (fieldname) => {
    if (formik.touched[fieldname] && formik.errors[fieldname]) {
      return "is-invalid";
    }

    if (formik.touched[fieldname] && !formik.errors[fieldname]) {
      return "is-valid";
    }

    return "";
  };

  const formik = useFormik({
    initialValues,
    enableReinitialize: true,
    validationSchema: CancelSubscriptionSchema,
    onSubmit: handleSubmit,
    onReset: handleReset,
  });

  const handleDiscard = () => {
    canvaCancel("kt_CancelSubscription_panel_close");
    formik.resetForm();
  };

  useEffect(() => {
    if (
      orderDetail?.collection_date &&
      isDateWithinNext3Days(orderDetail?.collection_date)
    ) {
      cancellationPrice().then((res) => setPrice(res.data.data));
    }
  }, [orderDetail.collection_date]);
  useEffect(() => {
    if (isDateToday(orderDetail?.collection_date)) {
      formik.setFieldValue("credit_option", "none");
    } else {
      formik.setFieldValue("credit_option", "none");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderDetail.collection_date]);
  return (
    <div
      id="kt_CancelSubscription_panel"
      className="offcanvas offcanvas-right pt-5 pb-10"
    >
      <div className="offcanvas-header offcanvas-header-navs d-flex align-items-center justify-content-between mb-5">
        <div
          className="offcanvas-close mt-n1 pr-5"
          style={{ position: "absolute", top: "15px", right: "10px" }}
        >
          <span
            onClick={() => handleDiscard()}
            className="btn btn-xs btn-icon btn-light btn-hover-primary"
          >
            <i className="ki ki-close icon-sm text-muted"></i>
          </span>
        </div>
        <div id="kt_CancelSubscription_panel_close"></div>
      </div>
      {/*end::Header*/}
      <form onSubmit={formik.handleSubmit} onReset={formik.handleReset}>
        <div className="offcanvas-content px-10 ">
          <div>
            <h5>{intl.formatMessage({ id: "Cancel.Subscription" })}</h5>
          </div>
          <div
            className="fade pt-3 pr-5 mr-n5 scroll active show ps--active-y mt-10"
            id="kt_quick_panel_logs_kt_CancelSubscription_panel"
          >

  {/* Cancellation Category */}
  <div>
    <Form.Group>
      <Form.Label>Cancellation Category</Form.Label>
      <FormControl fullWidth>
        <Select
          name="cancel_category"
          MenuProps={{
            anchorOrigin: { vertical: "bottom", horizontal: "left" },
            transformOrigin: { vertical: "top", horizontal: "left" },
            getContentAnchorEl: null,
          }}
          IconComponent={(props) => (
            <i {...props}>
              <KeyboardArrowDownIcon />
            </i>
          )}
          inputProps={{ "aria-label": "Without label" }}
          displayEmpty
          className={`form-control w-100 ${getInputClasses("cancel_category")}`}
          {...formik.getFieldProps("cancel_category")}
          onChange={(e) => {
            formik.setFieldValue("cancel_category", e.target.value);
            formik.setFieldValue("cancel_reason", ""); // reset reason when category changes
          }}
        >
          <MenuItem value="">Select Category</MenuItem>
          <MenuItem value="Pricing & Value">Pricing & Value</MenuItem>
          <MenuItem value="Access & Logistics">Access & Logistics</MenuItem>
          <MenuItem value="Customer Situation">Customer Situation</MenuItem>
          <MenuItem value="Customer Experience">Customer Experience</MenuItem>
          <MenuItem value="Administrative & Other">Administrative & Other</MenuItem>
        </Select>
      </FormControl>
      {formik.touched.cancel_category && formik.errors.cancel_category ? (
        <div className="fv-plugins-message-container">
          <div className="fv-help-block">{formik.errors.cancel_category}</div>
        </div>
      ) : null}
    </Form.Group>
  </div>

  {/* Cancel Reason */}
  {formik.values.cancel_category && (
    <div>
      <Form.Group className="mb-5">
        <Form.Label>Cancel Reason</Form.Label>
        <FormControl fullWidth>
          <Select
            name="cancel_reason"
            MenuProps={{
              anchorOrigin: { vertical: "bottom", horizontal: "left" },
              transformOrigin: { vertical: "top", horizontal: "left" },
              getContentAnchorEl: null,
            }}
            IconComponent={(props) => (
              <i {...props}>
                <KeyboardArrowDownIcon />
              </i>
            )}
            inputProps={{ "aria-label": "Without label" }}
            displayEmpty
            className={`form-control w-100 ${getInputClasses("cancel_reason")}`}
            {...formik.getFieldProps("cancel_reason")}
          >
            <MenuItem value="">Select Reason</MenuItem>
            {getReasonsByCategory(formik.values.cancel_category).map((reason, index) => (
              <MenuItem value={reason} key={index}>{reason}</MenuItem>
            ))}
          </Select>
        </FormControl>
        {formik.touched.cancel_reason && formik.errors.cancel_reason ? (
          <div className="fv-plugins-message-container">
            <div className="fv-help-block">{formik.errors.cancel_reason}</div>
          </div>
        ) : null}
      </Form.Group>
    </div>
  )}

  <div>
    <Form.Group className="mb-5">
      <p className="text-danger mt-2">
        <sup>*</sup>
        Note : For Refund, Use "Action → Invoices → Refund" section.
      </p>
    </Form.Group>
  </div>
</div>

            </div>
        <div className="offcanvas-footer">
          <div className="offcanvas-content text-right ">
            <button
              type="reset"
              className="btn btn-dark font-weight-bolder font-size-sm mr-3 "
              onClick={() => handleDiscard()}
            >
              {intl.formatMessage({ id: "CANCEL" })}
            </button>
            <button
              disabled={loading}
              type="submit"
              className="btn btn-primary font-weight-bolder font-size-sm "
            >
              {intl.formatMessage({ id: "SAVE" })}
              {loading && <span className="spinner spinner-white mr-4"></span>}
            </button>
          </div>
        </div>
      </form>
      {snack.call ? <SnackBarTool {...snack} /> : ""}
    </div>
  );
}
